import Select from 'react-select'
import HardwareSelect from './HardwareSelect'
import { DIRECT_X_OPTIONS, HARDWARE_TYPES } from './systemRequirementHelper'

const SystemRequirementBox = ({ title, value, onChange, osOptions }) => {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue })
  }

  const selectedOs = osOptions.filter((option) => value.os.includes(option.value))
  const selectedDirectX = DIRECT_X_OPTIONS.filter((option) =>
    value.directX.includes(option.value)
  )

  return (
    <div className="systemRequirementBox">
      <div className="systemRequirementBox__title">{title}</div>

      <div className="systemRequirementBox__arch">
        <label>
          <input
            type="checkbox"
            checked={value.x32}
            onChange={(e) => updateField('x32', e.target.checked)}
          />
          <span>x32</span>
        </label>
        <label>
          <input
            type="checkbox"
            checked={value.x64}
            onChange={(e) => updateField('x64', e.target.checked)}
          />
          <span>x64</span>
        </label>
      </div>

      <div className="systemRequirementBox__field">
        <input
          type="text"
          placeholder="Requirement"
          value={value.requirement}
          onChange={(e) => updateField('requirement', e.target.value)}
        />
      </div>

      <div className="systemRequirementBox__field">
        <Select
          placeholder="OS"
          value={selectedOs}
          options={osOptions}
          onChange={(options) =>
            updateField('os', options ? options.map((item) => item.value) : [])
          }
          isMulti
          isRtl
          isClearable
        />
      </div>

      <div className="systemRequirementBox__field">
        <HardwareSelect
          type={HARDWARE_TYPES.CPU}
          placeholder="CPU"
          value={value.cpu}
          onChange={(options) => updateField('cpu', options || [])}
          isMulti
        />
      </div>

      <div className="systemRequirementBox__field">
        <HardwareSelect
          type={HARDWARE_TYPES.GPU}
          placeholder="GPU"
          value={value.gpu}
          onChange={(options) => updateField('gpu', options || [])}
          isMulti
        />
      </div>

      <div className="systemRequirementBox__field">
        <Select
          placeholder="DirectX"
          value={selectedDirectX}
          options={DIRECT_X_OPTIONS}
          onChange={(options) =>
            updateField('directX', options ? options.map((item) => item.value) : [])
          }
          isMulti
          isRtl
          isClearable
        />
      </div>
      
      <div className="systemRequirementBox__numbers">
        <div className="systemRequirementBox__field">
          <label>VRAM (GB)</label>
          <input
            type="number"
            min={0}
            step="0.1"
            placeholder="GB"
            value={value.vRam}
            onChange={(e) => updateField('vRam', e.target.value)}
          />
        </div>
        <div className="systemRequirementBox__field">
          <label>RAM (GB)</label>
          <input
            type="number"
            min={0}
            step="0.1"
            placeholder="GB"
            value={value.ram}
            onChange={(e) => updateField('ram', e.target.value)}
          />
        </div>
        <div className="systemRequirementBox__field">
          <label>Storage (GB)</label>
          <input
            type="number"
            min={0}
            step="0.1"
            placeholder="GB"
            value={value.storage}
            onChange={(e) => updateField('storage', e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

export default SystemRequirementBox
